import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wActs from "../actions/website-actions";
import {Link} from "react-router-dom";
import SideBanners from "../components/sidebanners";
import SubHeader from "../components/subheader";
import LinkHeader from "../components/linkheader";


class Support extends Component {

  componentDidMount() {

  }


  handleSubmit(evt) {
    let dta = {
      Name: this.formName.value,
      Email: this.formEmail.value,
      Message: this.formMessage.value,
    };
    this.props.dispatch(wActs.SendSupportMessage(dta))
  }

  getTranslation(key) {
    return wActs.getTranslation(this.props.WebPage.Translations,key);
  }
  render() {

    let hHtml = wActs.getTranslation(this.props.WebPage.Translations, "page.support.header");
    if(!wActs.isNullOrEmpty(this.props.WebPage.Page.Content.Main)) {
      hHtml = this.props.WebPage.Page.Content.Main;
    }

    return (
      <div className={`main`}>
        <SubHeader/>
        <div className="container">
          <LinkHeader/>
          <div className="content flex flex--between">
            <SideBanners isLeft={true}/>
            <div className="contact-page">
              <div className="title">
                <div className="h2">
                  {wActs.getTranslation(this.props.WebPage.Translations,"page.support.writetous")}
                </div>
                <div className="descr-block" dangerouslySetInnerHTML={{__html: hHtml}}></div>
                <div className="content">
                  <form action="#">
                    <div className="form-row flex flex--between">
                      <div className="input-wrapper">
                        <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.yourname")}</span>
                        <div className="input-container">
                          <input className="input" ref={(ref) => {this.formName = ref;}} type="text" placeholder="John Smith" name="" defaultValue={this.props.WebPage.Support.Response.Name} />
                          <span className="ico">
												<i className="fa fa-user"></i>
											</span>
                        </div>
                      </div>

                      <div className="input-wrapper">
                        <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.email")}</span>
                        <div className="input-container">
                          <input className="input" ref={(ref) => {this.formEmail = ref;}} type="email" placeholder="example@gmail.com" name="" defaultValue={this.props.WebPage.Support.Response.EmailAddress} />
                          <span className="ico">
												<i className="fa fa-envelope"></i>
											</span>
                        </div>
                      </div>

                    </div>


                    <div className="input-wrapper">
                      <span className="input-title">{wActs.getTranslation(this.props.WebPage.Translations,"page.yourmessage")}</span>
                      <div className="input-container">
                        <textarea className="input" ref={(ref) => {this.formMessage = ref;}}  placeholder={this.getTranslation("page.writeyourmessagehere")} defaultValue={this.props.WebPage.Support.Response.Text}></textarea>
                        <span className="ico">
											<i className="fa fa-comment"></i>
										</span>
                      </div>
                    </div>

                    <input onClick={(e)=> {this.handleSubmit(e)}} type="button" className="btn btn--blue" value={wActs.getTranslation(this.props.WebPage.Translations,"page.submit")}/>
                  </form>
                </div>
              </div>
            </div>
            <SideBanners isLeft={false}/>
          </div>
        </div>
        <div className="clear"></div>
        <div className="seo-container">
          <h1 className={"h1-top"} style={{marginBottom: "5px"}}>{this.props.WebPage.Page.H1Text}</h1>
        </div>
        <div className="seo-container">
          {(!wActs.isNullOrEmpty(this.props.WebPage.Page.H1TextBlock)) &&
          <p ref={(r) => {this.BottomSeo = r}} className="h1textblock" style={{textAlign: "justify",padding: "10px"}} dangerouslySetInnerHTML={{__html: this.props.WebPage.Page.H1TextBlock}}></p>
          }
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Support);
